import consola from "consola"

import resetMixin from "~/mixins/store/resetToInitialState"

import pay_mixin from "~/mixins/band/payin/pay"

const initialState = function () {
  return {
    cards: [],
    selected_card_id: 0,
    error_code: 0,
  }
}

export const state = initialState

export const mutations = {
  SET_AVAILABLE_CARDS: function (state, new_card_set) {
    state.cards.splice(0, state.cards.length)
    for (var i = new_card_set.length - 1; i >= 0; i--) {
      new_card_set[i].id = Number(new_card_set[i].Id)
      state.cards.push(new_card_set[i])
    }
  },
  ADD_CARD: function (state, new_card) {
    new_card.id = Number(new_card.Id)
    state.cards.unshift(new_card)
  },
  SELECT_CARD: function (state, card_id) {
    if (typeof card_id !== "number") consola.warn("Prvided card id is NaN")
    else state.selected_card_id = card_id
  },
  SET_ERROR: function (state, error_code) {
    state.error_code = error_code
  },
  REMOVE_CARD_BY_ID: function (state, card_id) {
    var i = state.cards.length - 1

    for (; i >= 0; i--) {
      if (state.cards[i].id === card_id) break
    }
    if (state.selected_card_id === card_id) state.selected_card_id = 0
    state.cards.splice(i, 1)
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: function ({ commit }) {
    commit("RESET")
  },
  FETCH: async function ({ commit }) {
    const ret = await this.$axios.$get("/mangopay/card/")

    commit("SET_AVAILABLE_CARDS", ret)
    return ret
  },
  PAY: async function ({ state, getters, rootState, rootGetters, commit }) {
    const data = {
      invoice_context: {
        ...getters["PAYMENT_DATA"],
        legal_data: rootState.payin.billing_infos.legal_data.id,
        origin:
          rootGetters["payin/PURCHASE_TYPE"] === "sendtrack"
            ? `/draft/${rootState.draft.id}/recap/`
            : "/band/shop/",
      },
      AuthorId: rootState.payin.billing_infos.natural_user.id,
      CardId: state.selected_card_id,
      user: rootState.user.id,
    }
    const vm = this

    return new Promise(
      function (resolve, reject) {
        pay_mixin.methods
          .lock_safeguard(
            async function () {
              return await vm.$axios.$post("/mangopay/payin/", data)
            },
            data,
            "/mangopay/payin/",
            vm.$axios
          )
          .then((ret) => {
            if (ret.SecureModeNeeded === true && ret.Status === "CREATED") {
              if (ret.SecureModeRedirectURL.match(/https?:\/\//) === null)
                ret.SecureModeRedirectURL =
                  "http://" + ret.SecureModeRedirectURL
              resolve(ret.SecureModeRedirectURL)
            } else {
              resolve()
            }
          })
          .catch((resp) => {
            const code = Number(resp?.response?.data?.code ?? 420690)
            commit("payin/SET_PROCESSING_STATUS", false)
            commit("SET_ERROR", code)
            commit("REMOVE_CARD_BY_ID", state.selected_card_id)
            reject(resp)
          })
      }.bind(this)
    )
  },
}

export const getters = {
  PAYMENT_DATA: function (state, getters, rootState, rootGetters) {
    return rootGetters["payin/payment_method/PAYMENT_DATA"]
  },
}
